const styles: any = {
    noPaddingCol: {
		paddingInline: 0,
		width: '100%',
	},
};

export default styles;
